import React from 'react';
import Equalizer from 'react-equalizer';
import {NavLink as Link} from 'react-router-dom';
import ImageResponsive from '../../../contentful/ImageResponsive';

class EquipmentsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideArchived: true
    };
  }

  toggleShowArchived() {
    this.setState({
      hideArchived: !this.state.hideArchived
    });
  }

  render() {
    return (
      <div>
        <div className="pull-right">
          <Link
            to={`/equipment/new/${this.props.modelId}`}
            className={`${this.props.modelModified ? 'disabled ' : ''}btn btn-default`}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> Legg til tilbehør
          </Link>
          &nbsp;
          <Link
            to={`/equipmentGroup/equipment/new/${this.props.modelId}`}
            className={`${this.props.modelModified ? 'disabled ' : ''}btn btn-default`}
          >
            <i className="fa fa-plus" aria-hidden="true"></i> Legg til gruppe
          </Link>
          &nbsp;
          <button onClick={(e) => {
            e.preventDefault();
            this.toggleShowArchived();
          }} className="btn btn-info" disabled={this.state.working}>
            {this.state.hideArchived ? 'Vis arkiverte' : 'Skjul arkiverte'}
          </button>
        </div>
        <div className="row clearboth">
          <Equalizer byRow={false}>
            {this.props.equipments.map((eq) => {
              if (this.state.hideArchived && eq.archived) {
                return;
              }

              let statusClass = 'warning';
              let text = 'Kladd';

              if (eq.published) {
                if (eq.updated) {
                  statusClass = 'info';
                  text = 'Oppdatert';
                } else {
                  statusClass = 'success';
                  text = 'Publisert';
                }
              } else if (eq.archived) {
                statusClass = 'danger';
                text = 'Arkivert';
              }

              let toLink = `/equipment/${eq.id}`;
              if (eq.group) {
                toLink = `/equipmentGroup/equipment/${eq.id}`;
              }

              return (
                <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3" title={text} key={eq.id}>
                  <div className={`panel panel-${statusClass}`}>
                    <div className="panel-heading">
                      <h3 className="panel-title">
                        {eq.nameCustom || eq.name}
                        {eq.group && <span className="pull-right mf-margin-left-10">(Gruppe)</span>}
                        {!eq.group && eq.includedEquipment?.length > 0 && <span className="pull-right mf-margin-left-10">(Pakke)</span>}
                        {eq.informationFile && <div className="pull-right mf-margin-left-10"><i title="Tilbehøret har informasjonsfil lastet opp" className="fa fa-file-o" aria-hidden="true"></i></div>}
                      </h3>
                    </div>
                    <div className="panel-body">
                      <div className="row">
                        <div className="col-xs-12 mf-margin-bottom-10">
                          {eq.image &&
                            <ImageResponsive
                              src={eq.image.url}
                              width={300}
                              height={200}
                              aspect={1.5}
                            />
                          }
                        </div>

                        {!eq.group && <>
                          <div className="col-xs-6">
                            <strong>Varenr</strong>
                          </div>
                          <div className="col-xs-6">
                            {eq.eqId}
                          </div>

                          <div className="clearfix"></div>

                          <div className="col-xs-6">
                            <strong>Kategori</strong>
                          </div>
                          <div className="col-xs-6">
                            {eq.category}
                          </div>

                          <div className="clearfix"></div>

                          <div className="col-xs-6">
                            <strong>Pris</strong>
                          </div>
                          <div className="col-xs-6">
                            {eq.totalPrice}
                          </div>

                          <div className="clearfix"></div>

                          <div className="col-xs-6">
                            <strong>Beskrivelse</strong>
                          </div>
                          <div className="col-xs-6">
                            <i>{eq.descriptionCustom ? 'Egendefinert' : 'Standard'}</i>
                          </div>

                          {(eq.includedEquipment ?? []).length > 0 && (
                            <>
                              <div className="clearfix" />
                              <div className="col-xs-6">
                                <strong>Inkludert tilbehør</strong>
                              </div>
                              <div className="col-xs-6">
                                <i>{eq.includedEquipment.length} stk</i>
                              </div>
                            </>
                          )}
                        </>}

                        {eq.group && <>
                          <div className="col-xs-6">
                            <strong>Kategori</strong>
                          </div>
                          <div className="col-xs-6">
                            {eq.category}
                          </div>
                          <div className="clearfix"></div>
                          <div className="col-xs-6">
                            <strong>Tilbehør i gruppen</strong>
                          </div>
                          <div className="col-xs-6">
                            <i>{eq.includedEquipment.length} stk</i>
                          </div>
                        </>}


                      </div>
                    </div>
                    <div className="panel-footer">
                      <Link
                        to={toLink}
                        disabled={(this.props.disabled)}
                        className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
                      >
                        <i className="fa fa-pencil" aria-hidden="true"></i> Endre
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </Equalizer>
        </div>
      </div>
    );
  }
}

export default EquipmentsList;
